import { createApp } from 'vue'
import StafetAddDeltager from './StafetAddDeltager'

const el = '.kb-component--stafet-flow-add-participants'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetAddDeltagerDOM) => {
            const component = createApp(StafetAddDeltager).use(Store)
            component.mount(StafetAddDeltagerDOM)
        })
    }
}
